import { render, staticRenderFns } from "./departmentTreeList.vue?vue&type=template&id=712d57c7&"
import script from "./departmentTreeList.vue?vue&type=script&lang=js&"
export * from "./departmentTreeList.vue?vue&type=script&lang=js&"
import style0 from "./departmentTreeList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports